import { render, staticRenderFns } from "./extDialog.vue?vue&type=template&id=ecac381e&"
import script from "./extDialog.vue?vue&type=script&lang=js&"
export * from "./extDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports